export const LEGO_LOCALES = new Set([
  'nl-nl',
  'nl-be',
  'de-de',
  'de-at',
  'de-ch',
  'fr-fr',
  'fr-be',
  'fr-ch',
  'it-it',
  'es-es',
  'pt-pt',
  'da-dk',
  'fi-fi',
  'sv-se',
  'nb-no',
  'pl-pl',
  'cs-cz',
  'hu-hu',
  'ro-ro',
  'en-gb',
  'en-ie',
  'en-us',
]);

// Language-only browser settings (e.g. "nl") mapped to a default shop.
const LANG_DEFAULTS = {
  nl: 'nl-nl',
  de: 'de-de',
  fr: 'fr-fr',
  it: 'it-it',
  es: 'es-es',
  pt: 'pt-pt',
  da: 'da-dk',
  fi: 'fi-fi',
  sv: 'sv-se',
  nb: 'nb-no',
  no: 'nb-no',
  pl: 'pl-pl',
  cs: 'cs-cz',
  hu: 'hu-hu',
  ro: 'ro-ro',
};

// Same resolver for request Accept-Language and navigator.language. Unknown
// regions/languages use the Danish shop; a browser language is not geolocation.
export function resolveLegoLocale(language = '') {
  const lang = language.split(',')[0].split(';')[0].trim().toLowerCase();
  const locale = LEGO_LOCALES.has(lang) ? lang : LANG_DEFAULTS[lang.split('-')[0]] || 'da-dk';
  const [languageCode, country] = locale.split('-');
  return `${languageCode}-${country.toUpperCase()}`;
}
